var exports = {
  "zr": "x93eb46d8--593f16--root",
  "me": "x93eb46d8--593f16--separator",
  "O0": "x93eb46d8--593f16--rating",
};

module.exports = exports;
